import { useSelector } from 'react-redux';
import { SharedReduxState } from '../../../../reducers/types';
import { PREFERENCE } from '../../const/preferences';
import { THEME_TYPE } from '../../../../../../ui-lib/consts';

export const useThemeMode = () => {
  return useSelector((state: SharedReduxState) => state.userPreferences ?
    state.userPreferences[PREFERENCE.THEME_MODE] : THEME_TYPE.LIGHT);
};